import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.lenses";
export interface PersistentStore {
    store: Uint8Array;
}
function createBasePersistentStore(): PersistentStore {
    return { store: new Uint8Array(0) };
}
export const PersistentStore: MessageFns<PersistentStore> = {
    encode(message: PersistentStore, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.store.length !== 0) {
            writer.uint32(10).bytes(message.store);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): PersistentStore {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePersistentStore();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.store = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<PersistentStore>, I>>(base?: I): PersistentStore {
        return PersistentStore.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PersistentStore>, I>>(object: I): PersistentStore {
        const message = createBasePersistentStore();
        message.store = object.store ?? new Uint8Array(0);
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {
    $case: string;
} ? {
    [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]>;
} & {
    $case: T["$case"];
} : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
